import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { BranchesContext } from "../../context/BranchesContext";
import { NewRequestContext } from "../../context/NewRequestContext";
import { deleteBranch, useGetBranchPaymentInfo, useGetClients, useGetNewRequestBranchesByClient, useGetNewRequestClientDevices } from "../../utils/clients-hooks";
import { resourceCache, useAsyncResource } from "use-async-resource";
import { fetchDashboardBranchById, fetchRemindersAll, fetchTasksAll, fetchTasksYours, fetchTroublesAll, useGetBranchImage } from "../../utils/dashboard-hooks";
import { useGetUsers } from "../../utils/users-hooks";
import { MapBranch } from "../../models/dashboard-models";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBolt, faExclamationTriangle, faHourglassHalf, faTimes, faTint } from "@fortawesome/free-solid-svg-icons";
import { CustomButton } from "../CustomButton";
import { AddActionComponent } from "../AddActionComponent";
import { AddReminder } from "../../pages/AddReminder";
import { AddTrouble } from "../../pages/AddTrouble";
import { Role } from "../../utils/Enums/Roles";
import { toastOptionsTopRight } from "../../utils/Enums/ToastOptions";
import { CustomToastContent } from "../CustomToastContent";
import { InfoModal } from "../InfoModal";
import { toast } from "react-toastify";
import { useGetReferencesForDistributor } from "../../utils/warehouses-hooks";
import { NewRequest } from "../../pages/NewRequest";
import noImage from '../../assets/No_image_available.png';

export const MarkerInfoBox = ({ selectedBranch }: { selectedBranch: MapBranch }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { hasPermission } = useContext(AuthContext);
    const [showDelete, setShowDelete] = useState(false);
    const [reason, setReason] = useState('');
    const { setLastSelectedBranch, fetchNewReminders, fetchNewTroubles, setSelectedBranches, removeBranchLocal } =
        useContext(BranchesContext);
    const { onBranchSelect, onClientSelect } = useContext(NewRequestContext);
    const [showNewRequestModal, setShowNewRequestModal] = useState(false);

    const [readClients] = useAsyncResource(useGetClients, {});
    const [readDashboardBranch] = useAsyncResource(fetchDashboardBranchById, selectedBranch.id);
    const [getBranchImage] = useGetBranchImage(selectedBranch.id);
    const dashboardBranch = readDashboardBranch();
    const branchDetails = { ...selectedBranch, ...dashboardBranch };
    const image = getBranchImage();
    const allClients = readClients();
    const [getDistributors] = useAsyncResource(useGetUsers, undefined, 'DISTRIBUTOR,INSTALLER');
    const { items: distributors } = getDistributors();
    const [showModal, setShowModal] = useState(false);

    const FetchData = async () => {
        const client = allClients?.items.find((client) => client.companyName === branchDetails.companyName);
        const id = client?.id || 0;
        const branches = await useGetNewRequestBranchesByClient(id);
        let branch = {
            ...branches?.items.find((branch) => branch.id === branchDetails.id),
            nextMaintenanceDate: branchDetails.nextMaintenanceDate,
        };
        const distributor = distributors.find((user) => user?.id === branchDetails.assignedDistributor);

        onClientSelect(client);
        onBranchSelect({ ...branch, assignedDistributor: distributor });
        setShowNewRequestModal(true);
        // New
        // Store opened Branch info modal into
        localStorage.setItem('isModalOpen', JSON.stringify(true));
        localStorage.setItem('selectedClient', JSON.stringify(client));
        // New END
    };

    const getCompanyName = (name: string) => {
        const selectedClient = localStorage.getItem('selectedClient');
        let updateName = name;
        if (selectedClient) {
            updateName = JSON.parse(selectedClient).companyName;
        }
        return updateName;
    };

    const selectedBranchName = (name: string) => {
        const selectedBranch = localStorage.getItem('selectedBranch');
        let updateName = name;
        if (selectedBranch) {
            updateName = JSON.parse(selectedBranch).name || name;
        }
        return updateName;
    }

    return (
        <>
            <div className='info-box-content bg-white position-absolute rounded overflow-hidden'>
                <div className='info-box-content'>
                    <div className='branch-content-container bg-white d-flex flex-column'>
                        <Button
                            variant='btn-link'
                            className='info-box-close-button bg-none'
                            onClick={() => {
                                localStorage.removeItem('selectedBranch');
                                localStorage.removeItem('markerID');
                                setLastSelectedBranch(null);
                                setSelectedBranches((prevState) =>
                                    prevState.filter(({ id }) => selectedBranch.id !== id)
                                );
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} color='white' className='fa-fw' />
                        </Button>
                        <div className='d-flex flex-column  p-1  mb-0 position-relative'>
                            <div className='d-flex justify-content-between ps-2 pe-4'>
                                <div className='d-flex align-items-center'>
                                    <FontAwesomeIcon
                                        icon={faTint}
                                    color={branchDetails.oilState}
                                        size='lg'
                                        className='fa-fw'
                                    />
                                    <h6 className='mb-0 pt-1'>
                                        {branchDetails.oilPercent === 0 ? 0 : branchDetails.oilPercent || '-'}%
                                    </h6>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <FontAwesomeIcon
                                        icon={faBolt}
                                        color={branchDetails.batteryState}
                                        size='lg'
                                        className='fa-fw'
                                    />
                                    <h6 className='mb-0 pt-1'>
                                        {branchDetails.batteryPercent === 0 ? 0 : branchDetails.batteryPercent || '-'}
                                        %
                                    </h6>
                                </div>
                                <div className='d-flex align-items-center text-center px-1'>
                                    <FontAwesomeIcon
                                        icon={faHourglassHalf}
                                        color={branchDetails.maintenanceState}
                                        size='lg'
                                        className='fa-fw '
                                    />
                                    <h6 className='mb-0 pt-1'>
                                        {branchDetails.maintenanceDays === 0
                                            ? 0
                                            : branchDetails.maintenanceDays || '-'}
                                    </h6>
                                </div>
                            </div>
                            <div className='d-flex flex-row  p-1 text-center'>
                                <CustomButton
                                    title={selectedBranchName(branchDetails.name ?? String(branchDetails.id))}
                                    className='w-100 branch-name-button'
                                    variant='outline-dark'
                                    onClick={() => {
                                        FetchData();
                                    }}
                                />
                            </div>
                            <div className='d-flex flex-row  p-1 pb-2 text-center'>
                                <h6 className='mb-0 px-1 w-100 fw-bold'>
                                    {getCompanyName(branchDetails.companyName ?? '')}
                                </h6>
                            </div>
                            <div className='branch-image-container rounded'>
                                {image ? (
                                    <img
                                        src={image}
                                        alt='branch'
                                        className='branch-image'
                                        onClick={() => setShowModal(true)}
                                    />
                                ) : (
                                    <img
                                        src={noImage}
                                        className='branch-image not-available'
                                        alt='not available'
                                        onClick={FetchData}
                                    />
                                )}
                            </div>
                            <Modal
                                show={showModal}
                                onHide={() => setShowModal(false)}
                                size='lg'
                                centered
                                className={'transparent-modal'}
                            >
                                <Modal.Body>
                                    <div className='d-flex w-100 justify-content-center p-0 m-0'>
                                        <img src={image} alt='branch' className='image' />
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <div className='info-box-icon add-reminder d-flex justify-content-center align-items-center'>
                                <AddActionComponent
                                    title='Add Reminder'
                                    addComponent={AddReminder}
                                    itemRelatedId={selectedBranch.id}
                                    refetchEntitiesHook={() => {
                                        resourceCache(fetchRemindersAll).clear();
                                        fetchNewReminders();
                                    }}
                                    customButton={(showModal) => (
                                        <FontAwesomeIcon
                                            icon={faBell}
                                            color='white'
                                            style={{
                                                width: '20px',
                                                verticalAlign: 0,
                                            }}
                                            size='lg'
                                            onClick={showModal}
                                        />
                                    )}
                                />
                            </div>
                            <div className='info-box-icon add-trouble d-flex justify-content-center align-items-center'>
                                <AddActionComponent
                                    title='Add Trouble'
                                    addComponent={AddTrouble}
                                    itemRelatedId={selectedBranch.id}
                                    refetchEntitiesHook={() => {
                                        resourceCache(fetchTroublesAll).clear();
                                        fetchNewTroubles();
                                    }}
                                    customButton={(showModal) => (
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            color='white'
                                            style={{
                                                width: '20px',
                                                verticalAlign: 0,
                                            }}
                                            onClick={showModal}
                                            size='lg'
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        {hasPermission([Role.ADMIN]) && (
                            <div className='d-flex flex-row p-1 text-center'>
                                <CustomButton
                                    title={t('delete')}
                                    className='w-100 branch-name-button'
                                    variant='outline-danger'
                                    onClick={() => {
                                        setShowDelete(() => true);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <InfoModal
                show={showDelete}
                isDisabled={reason.length < 1}
                onHide={(isDelete: boolean) => {
                    if (isDelete) {
                        deleteBranch(selectedBranch.id, reason).then(() => {
                            toast.success(<CustomToastContent content={[t('success')]} />, toastOptionsTopRight);

                            // OPTIMISTIC UPDATE: Remove from local state instead of clearing all caches
                            removeBranchLocal(selectedBranch.id);

                            // Keep these specific cache clears
                            resourceCache(useGetNewRequestClientDevices).clear();
                            resourceCache(useGetReferencesForDistributor).clear();
                            resourceCache(fetchTasksAll).clear();
                            resourceCache(fetchTasksYours).clear();
                            resourceCache(useGetBranchPaymentInfo).clear();

                            // REMOVED: resourceCache(fetchMapBranches).clear();

                            localStorage.removeItem('selectedBranch');
                            localStorage.removeItem('markerID');
                            setLastSelectedBranch(null);
                            setSelectedBranches((prevState) => prevState.filter(({ id }) => selectedBranch.id !== id));
                        });
                    }
                    setReason('');
                    setShowDelete(false);
                }}
            >
                <span className='w-100 text-secondary'>{`*${t('commentRequired')}`}</span>

                <Form.Control
                    placeholder={t('freetext')}
                    className={'freetext'}
                    name={'freetext'}
                    onChange={(e) => setReason(e.currentTarget.value)}
                    value={reason}
                />
            </InfoModal>

            {showNewRequestModal && (
                <NewRequest showModal={showNewRequestModal === true ? true : false} setShowModal={setShowNewRequestModal} />
            )}
        </>
    );
};
